export enum ContractTypeAPIResponse {
  Lease = 'lease',
  PPA = 'ppa',
  LeaseAndPPA = 'leaseAndPPA',
  EPC = 'epc',
  ESA = 'esa',
}
